export const isDevelopment = process.env.NODE_ENV === "development";
export const config = {
  BASE_URL: isDevelopment ? "http://localhost:5000/api" : `./api`,
};
